<template lang="cur_tutor_lang">
<div class="hello">
    <Menu></Menu>
    <div class="class">
        <div class="top wrap">
            <h2 class="bold">{{ classinfo.classname }}</h2>
            <p>각 항목들을 클릭하시면 해당 정보를 확인할 수 있습니다.</p>
        </div>
        <div class=" wrap">
            <div v-if="classinfo.attend_state=='Y'" style="padding-bottom:20px;" class="naver-wrap">
                <button class="btn-line-gr" @click="setAttend(classinfo.classid,classinfo.idx_attend)">Class 출석체크</button>
            </div>
            <div v-else-if="classinfo.attend_state=='N' && classinfo.attend_date!='' && classinfo.attend_date!=null && classinfo.attend_edate ==''" style="padding-bottom:20px;" class="naver-wrap">
                <button class="btn-line-gr" @click="setAttendEnd(classinfo.classid,classinfo.idx_attend)">Class 퇴실</button>
            </div>
            <!--  -->
            <div v-else-if="classinfo.attend_state=='N' && classinfo.attend_date!='' && classinfo.attend_date!=null && classinfo.attend_edate !=''" class="gr mt10 naver-wrap" style="padding-bottom:20px">
                <button class="btn-line-gr-none"><i class="fas fa-check"></i>&nbsp;출석체크완료</button> {{ classinfo.attend_date }}
            </div>
            <div class="class-info">
                <table>

                    <tr v-if="classinfo.is_book=='Y' && (classinfo.bookname || classinfo.ebookinfo || classinfo.ebookinfo2 || classinfo.ebookinfo3)">
                        <th>교재</th>
                        <!-- <td v-if="classinfo.ebookinfo && classinfo.ebookinfo2 && classinfo.ebookinfo3"><a :href="classinfo.ebookinfo.bookurl" target="_blank">~</a></td> -->
                        <td>
                            <p v-if="classinfo.bookname">{{ classinfo.bookname }}</p>
                            <a v-if="classinfo.ebookinfo" :href="classinfo.ebookinfo.bookurl" target="_blank" class="ebook-title">{{ classinfo.ebookinfo.bookname }}</a><a v-if="classinfo.ebookinfo" :href="classinfo.ebookinfo.bookurl" class="view01">view</a><br v-if="classinfo.ebookinfo && (classinfo.ebookinfo2 || classinfo.ebookinfo3)">
                            <a v-if="classinfo.ebookinfo2" :href="classinfo.ebookinfo2.bookurl" target="_blank" class="ebook-title">{{ classinfo.ebookinfo2.bookname }}</a><a v-if="classinfo.ebookinfo2" :href="classinfo.ebookinfo2.bookurl" class="view01">view</a><br v-if="classinfo.ebookinfo2 && classinfo.ebookinfo3">
                            <a v-if="classinfo.ebookinfo3" :href="classinfo.ebookinfo3.bookurl" target="_blank" class="ebook-title">{{ classinfo.ebookinfo3.bookname }}</a><a v-if="classinfo.ebookinfo3" :href="classinfo.ebookinfo3.bookurl" class="view01">view</a>
                        </td>
                    </tr>
                    <!-- <tr v-if="classinfo.ebookinfo2">
                        <th>교재</th>
                        <td><a :href="classinfo.ebookinfo2.bookurl" target="_blank">{{ classinfo.ebookinfo2.bookname }}</a></td>
                    </tr>
                    <tr v-if="classinfo.ebookinfo3">
                        <th>교재</th>
                        <td><a :href="classinfo.ebookinfo3.bookurl" target="_blank">{{ classinfo.ebookinfo3.bookname }}</a></td>
                    </tr> -->
                    <tr v-if="classinfo.class_state==2 && classinfo.mov_book!=null">
                        <th>예복습</th>
                        <td><a :href="'/reviewlist?classid='+classid" class="view01">view</a></td>
                    </tr>
                    <tr>
                        <th>강사</th>
                        <td><a class="pointer" data-toggle="modal" href="#" onclick="return false;" @click="showTutor(classinfo.tutor_email,classinfo.tutor_ename,classinfo.tutor_photo,classinfo.language)">{{ classinfo.tutor_ename }}</a></td>
                    </tr>
                    <tr>
                        <th>매니저</th>
                        <td><a class="pointer" data-toggle="modal" href="#" onclick="return false;" @click="showManager(classinfo.hq_email,classinfo.hq_kname,classinfo.hq_photo,classinfo.hq_intu)">{{ classinfo.hq_kname }}</a></td>
                    </tr>
                </table>
            </div>

        </div>
        <div class="wrap">
            <ul class="tab">
                <li class="pointer " v-bind:class="{ active: tab == 1 }" @click="changeTab(1)" v-if="classinfo.use_writing == 'Y'"><img src="../assets/img/beta.png" alt="">Writing 첨삭</li>
                <li class="pointer" v-bind:class="{ active: tab == 2 }" @click="changeTab(2)">출결</li>
                <li class="pointer" v-bind:class="{ active: tab == 3 }" @click="changeTab(3)">강의계획서</li>
                <li class="pointer" v-bind:class="{ active: tab == 4 }" @click="changeTab(4)">EV</li>
            </ul>
        </div>

        <div class="wrap">
            <!-- writing 첨삭 -->
            <div class="writing" v-if="tab == 1">
                <div class="none-writing" v-if="writingList.length == 0">
                    <p>곧 과제가 안내될 예정입니다</p>
                </div>
                <div class="lecture " v-for="(item,index) in writingList" :key="index" v-if="writingList.length != 0">
                    <div class="wrap">
                        <div class="con">
                            <h3 class="bold mb-10 col-point">Writing {{item.writing_num}}회차</h3>
                            <table class="mb-20">
                                <tr>
                                    <th>안내일</th>
                                    <td class="pr-30">{{item.send_date_text}}</td>
                                    <th>마감일</th>
                                    <td>{{item.writing_date_text}}</td>
                                </tr>
                                <tr>
                                    <th>과제안내</th>
                                    <td class="pr-30"><a class="view02 pointer bold" @click="showTopicPop(item)">view</a></td>
                                    <th>과제제출</th>
                                    <td v-if="item.date_writing==''">
                                        <a class="view02 pointer bold" data-toggle="modal" data-target="#submitModal" @click="wirtigComfirmPage(item,item.writing_num)" v-if="item.class_end=='N'">제출하기</a>
                                        <span v-if="item.class_end=='Y'">마감</span>
                                    </td>
                                    <td v-else>                                                                         
                                        <a class="view02 pointer bold" v-show="!modChangeFlag(item)" @click="modConfirmPage(item,item.writing_num)">수정하기</a>
                                        <a v-if="item.correction_text=='' || item.correction_text==null" v-show="!modChangeFlag(item)" class="view02 pointer bold" data-toggle="modal" data-target="#submitModal" href="#" onclick="return false;" @click="writingDownload(item)">제출물({{item.date_writing}})</a>
                                        <a v-else class="view02 pointer bold" v-show="!modChangeFlag(item)" data-toggle="modal" data-target="#submitModal" href="#" onclick="return false;" @click="mswritingDownload(item)">제출물({{item.date_writing}})</a>
                                        <a v-if="item.correction_text=='' || item.correction_text==null" v-show="modChangeFlag(item)" class="view02 pointer bold" data-toggle="modal" data-target="#submitModal" href="#" onclick="return false;" @click="writingDownload(item)">제출완료({{item.date_writing}})</a>
                                        <a v-else class="view02 pointer bold" v-show="modChangeFlag(item)" data-toggle="modal" data-target="#submitModal" href="#" onclick="return false;" @click="mswritingDownload(item)">제출완료({{item.date_writing}})</a>
                                    </td>
                                </tr>
                                <tr>
                                    <th>첨삭현황</th>
                                    <td class="pr-30">
                                        <span v-if="item.date_correction==''" class="">-</span>
                                        <span v-if="item.date_correction!=''" class="view02 pointer" @click="correctionDownload(item)">첨삭보기</span>
                                    </td>
                                    <th v-if="writingInfo.use_writing_ev=='Y'">Ev</th>
                                    <td v-if="writingInfo.use_writing_ev=='Y'">
                                        <span v-if="item.ev_point_sum>0" class="view02 pointer" @click="showEvPop(item)">{{item.ev_point_sum}} (View)</span>
                                        <span v-if="item.ev_point_sum==0">-</span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
                <!-- <div class="lecture">
                    <div class="wrap">
                        <div class="con">
                            <h3 class="bold mb-10 col-point">Writing 1회차</h3>
                            <table class="mb-20">
                                <tr>
                                    <th>안내일</th>
                                    <td>2020-06-08</td>
                                    <th>마감일</th>
                                    <td>2020-06-12</td>
                                </tr>
                                <tr>
                                    <th>과제안내</th>
                                    <td><a class="view02 pointer">view</a></td>
                                    <th>과제제출</th>
                                    <td><a href="">제출완료(12/12)</a></td>
                                </tr>
                                <tr>
                                    <th>첨삭현황</th>
                                    <td><a class="view02 pointer" target="_blank">view</a></td>
                                    <th>평가서</th>
                                    <td><a class="view02 pointer">view</a></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div> -->
            </div>

            <!-- 출결 -->
            <div class="calendar-wrap" v-if="tab == 2">
                <div class="txt-right pr-20 pt-10" v-if="classinfo.is_statement == 'Y'">
                    <a class="font-14" :href="'/reasonadd?classid='+classid">불참사유서 제출</a><span style='color:#B7B7B7;' class="ml-10 mr-10">|</span><a class="font-14" :href="'/reasonlist?classid='+classid">내 불참사유서</a>
                </div>

                <ul class="calendar-top wrap">
                    <li class="pointer" v-on:click="set_cal_pre()"><img src="../assets/img/arrow-left.png" alt=""></li>
                    <li class="pointer">
                        <!-- <h4 class="bold">2020년 5월</h4> -->
                        <h4 class="bold" v-text=" cal_year + '년 ' + cal_month_str "></h4>
                    </li>
                    <li class="pointer" v-on:click="set_cal_next()"><img src="../assets/img/arrow-right.png" alt=""></li>
                </ul>
                <!-- <div class="txt-right mt-10 wrap">
                    <a href="" class="pointer col-point">+ 불참사유서 등록하기</a>
                </div> -->     
               
                    <div class="writing_attend" v-show ="( classinfo.use_writing=='Y' && classinfo.only_write=='Y' ) || classinfo.use_writing=='Y'">
                    <table id="app4">
                        <!-- <colgroup>
                            <col width="10%">
                            </col>
                            <col width="20%">
                            </col>
                            <col width="50%">
                            </col>
                        </colgroup> -->
                        <thead>
                            <tr>
                                <th>회차</th>          
                                <th>제출 </th>
                                <th>첨삭</th>                    
                                <th>EV</th>
                                <th>제출률</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template>
                            <tr v-if="writingUserListAttend.length == 0">
                                <td colspan='5'>
                                    출결 내역이 존재하지 않습니다.
                                </td>
                            </tr>
                            <tr v-else v-for="(itm,idx) in writingUserListAttend">
                                <td>{{itm.writing_num}}</td>                            
                                <td>
                                    <a v-if="itm.date_writing!=''" :href="itm.url_writing" target="blank">
                                        <i class="far fa-circle col-blue b"></i><br>({{itm.date_writing_short}})
                                    </a>
                                    <span v-else>{{ itm.writing_date_short }} </span>                                  
                                </td>
                                <td>
                                    <a v-if="itm.date_correction!=''" :href="itm.url_correction" target="blank">
                                        <i class="far fa-circle col-link b"></i><br>({{itm.date_correction_short |}})
                                    </a>
                                    <span v-else>-</span> 
                                </td>
                        
                                <td>
                                    <span v-if="itm.ev_point_sum>0" style="cursor : pointer;" @click="showEvPop(itm)" > {{itm.ev_point_sum}}   </span>     
                                    <span v-else > {{itm.ev_point_sum}}</span>
                                </td>
                                <td v-if="idx==0" :rowspan="writingUserListAttend.length" style="text-align:center; vertical-align: middle;" >                            
                                        {{Math.floor(complete_per)}} %                                                    
                                </td>
                            </tr>
                                    
                            </template>
                        </tbody>
                    </table>
                    </div>
                    <div  v-show="classinfo.use_writing=='N'">
                        <div class="calendar-col" >
                            <div class="wrap">
                                <span class="attend">출석</span>
                                <span class="absent">결석</span>
                                <span class="cancel">휴가/업무</span>
                                <span class="scheduled">예정수업</span>
                                <span class="reasons">공결(사유서 제출)</span>
                            </div>
                        </div>
                        <div class="calendar box" >
                            <ul class="day">
                                <li>SUN</li>
                                <li>MON</li>
                                <li>TUE</li>
                                <li>WED</li>
                                <li>THU</li>
                                <li>FRI</li>
                                <li>SAT</li>
                            </ul>
                            <ul class="date">
                                <li v-for="(cal_day,index) in cal_days" :key="index">
                                    <span v-bind:class="cal_day.style">{{ cal_day.txt }}</span>
                                </li>
                            </ul>
                    </div>
                </div>
            </div>

            <!-- 강의계획서 -->
            <div class="syllabus-wrap" v-if="tab==3">
                <div class="none-syllabus" v-if="syl_plan.plan_idx==0">
                    <p>강의계획서가 빠른시간 내에<br>업로드 될 예정입니다.</p>
                </div>
                <div class="syllabus-col" v-if="syl_plan.plan_idx>0">
                    <div class="tit_txt">1. Course Objectives</div>
                    <div class="syl_txt" v-html="syl_plan.courseobj_txt"></div>

                    <div class="tit_txt pt-30">2. Lesson Structure / Time Management</div>
                    <div class="timeline">
                        <div class="timeline-item" :date-is="syl_plan.timemng1+'min'">
                            <p>Greeting & Assignment Check</p>
                            <span class="hour"><span class="bold">0</span>hr</span>
                        </div>
                        <div class="timeline-item" :date-is="syl_plan.timemng2+'min'">
                            <p>Action Speech & Pronunciation Drill</p>
                        </div>
                        <div class="timeline-item" :date-is="syl_plan.timemng3+'min'">
                            <p>Main Textbook</p>
                        </div>
                        <div class="timeline-item" :date-is="syl_plan.timemng4+'min'">
                            <p>Sub Materials</p>
                        </div>
                        <div class="timeline-item" :date-is="syl_plan.timemng5+'min'">
                            <p>Review & Assignment</p>
                            <span class="hour"><span class="bold">{{ syl_plan.timemng6 }}</span>hr</span>
                        </div>
                    </div>

                    <div class="tit_txt pt-30">3. Lesson Plan for Session</div>
                    <div class="lession-plan">
                        <ul>
                            <li class="clear" v-for="(irow, i) in syl_plan.plan_week" :key="i" v-if="irow.mainbook != ''">
                                <div class="float-left w-20per">
                                    <p><span class="bold">{{ i + 1 }}</span><br>Week</p>
                                </div>
                                <div class="float-left w-80per">
                                    <h1>{{irow.mainbook}}</h1>
                                    <p>{{irow.submaterial}}</p>
                                </div>
                            </li>

                            <!-- <li>
                                <div class="float-left w-20per">
                                    <p><span class="bold">2</span><br>Week</p>
                                </div>
                                <div class="float-left w-80per">
                                    <h1>TOEIC Speaking 도전! Level 5</h1>
                                    <p>It is a long established fact that a reader will be distracted by the readable content</p>
                                </div>
                            </li> -->
                        </ul>
                    </div>
                </div>
            </div>

            <div class="ev-wrap" v-if="tab == 4">
               
                <EvReport v-if="ev_check_writing==true"  :visible="is_tab_ev" :classid="classid" :cal_year="cal_year" :cal_month="cal_month" @close="is_tab_ev=false"></EvReport>
            
                <div class="writing_attend" v-if="ev_check_writing==false">
                  <table id="app4">
                    <!-- <colgroup>
                        <col width="10%">
                        </col>
                        <col width="20%">
                        </col>
                        <col width="50%">
                        </col>
                    </colgroup> -->
                    <thead>
                        <tr>
                            <th>회차</th>                                                          
                            <th>EV</th>
                            
                        </tr>
                    </thead>
                    <tbody>
                       
                        <tr v-if="writingUserListAttend.length == 0">
                            <td colspan='2'>
                                Ev 내역이 존재하지 않습니다.
                            </td>
                        </tr>
                        <tr v-else v-for="(itm,idx) in writingUserListAttend">
                            <td>{{itm.writing_num}} 회차</td>                                                                           
                            <td>
                                <span v-if="itm.ev_point_sum>0" style="cursor:pointer;" @click="showEvPop(itm)" > {{itm.ev_point_sum}}   </span>     
                                <span v-else > {{itm.ev_point_sum}}</span>
                            </td>                           
                        </tr>                                                           
                    </tbody>
                </table>
                </div>
           
            </div>
        </div>

    </div>

    <!-- 푸터 -->
    <div class="footer clear">
        Copyright© <span class="bold">CARROT</span> Global Inc. All rights reserved.<br>
    </div>
    <TutorModal :visible="tutorVisible" :tutor_email="cur_tutor_email" :tutor_ename="cur_tutor_ename" :tutor_photo="cur_tutor_photo" :lang="cur_tutor_lang" @close="vue_close"></TutorModal>

    <ManagerModal :visible="mangerVisible" :manager_email="cur_manger_email" :manager_ename="cur_manger_ename" :manager_photo="cur_manger_photo" :manager_intu="cur_manger_intu" @close="vue_close"></ManagerModal>

    <WtGuideModal :visible="pop.email" :classid="classid" :memberseq="pop.memberseq" :info="pop.info" @close="pop.email=false"></WtGuideModal>

    <!-- 첨삭파일 업로드 팝업 -->
    <div v-if="showSendWriting" class="inf_box_smile_bg">

        <div class="inner_box">
            <img src="../assets/img/modal-close.png" alt="" class="close-img" v-on:click="showSendWriting=false">
            <!-- <i class="fa fa-times btn_smile_close" aria-hidden="true" v-on:click="showSendWriting=false"></i> -->
            <div class="smile_title">Writing 작성과제 제출하기</div>
            <div class="smile_box"> 
                <div class="smile_txt">{{sendWritingNum}}회차 제출입니다.</div>
                <div class="mt20">
                    <input id="writingFile" name="writingFile" type="file" class="file">
                </div>
                <div class="mt20">
                    <button class="button" @click="sendWritingConfirm()">제출하기</button>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="inf_box_smile_bg" >

<div class="inner_box">

<i class="fa fa-times btn_smile_close" aria-hidden="true" v-on:click="hideSmileSheet()"></i>

<div class="smile_title">첨삭만족도 조사</div>

<div class="smile_box">

<div class="smile_txt">강사님이 주신 첨삭은 어떠셨나요?<br><span class="imp">표정 아이콘</span>을 클릭해 주세요!<br>여러분의 소중한 의견이 더 좋은 수업을 만듭니다.</div>

<div class="icon_box fl" @click="sendSmileSheet(1)">

<img src="/resource/itmstudent/img/classlist/score1.png" class="img_size_smile" onmouseover="this.src='/resource/itmstudent/img/classlist/score1_on.png'" onmouseout="this.src='/resource/itmstudent/img/classlist/score1.png'">

</div>

<div class="icon_box fl" @click="sendSmileSheet(2)">

<img src="/resource/itmstudent/img/classlist/score2.png" class="img_size_smile" onmouseover="this.src='/resource/itmstudent/img/classlist/score2_on.png'" onmouseout="this.src='/resource/itmstudent/img/classlist/score2.png'">

</div>

<div class="icon_box fl" @click="sendSmileSheet(3)">

<img src="/resource/itmstudent/img/classlist/score3.png" class="img_size_smile" onmouseover="this.src='/resource/itmstudent/img/classlist/score3_on.png'" onmouseout="this.src='/resource/itmstudent/img/classlist/score3.png'">

</div>

<div class="cb"></div>

</div>

</div>

</div> -->

    <!-- <div class="inf_box_smile_bg" v-if="showSmileSheet==true">
        <div class="inner_box">
            <i class="fa fa-times btn_smile_close" aria-hidden="true" v-on:click="hideClassSmile()"></i>

            <div class="smile_title">첨삭만족도 조사</div>
            <div class="smile_box clear">
                <div class="clear">
                    <div class="icon_box float-left" v-on:click="sendSmileSheet(1)">
                        <img src="../assets/img/score1.png" class="img_size_smile" v-on:mouseover="changeImgover(1)" v-on:mouseout="changeImgOut(1)" id="smile_img1">
                    </div>
                    <div class="icon_box float-left" v-on:click="sendSmileSheet(2)">
                        <img src="../assets/img/score3.png" class="img_size_smile" v-on:mouseover="changeImgover(2)" v-on:mouseout="changeImgOut(2)" id="smile_img3">
                    </div>
                    <div class="icon_box float-left" v-on:click="sendSmileSheet(3)">
                        <img src="../assets/img/score5.png" class="img_size_smile" v-on:mouseover="changeImgover(3)" v-on:mouseout="changeImgOut(3)" id="smile_img5">
                    </div>
                </div>

                <div class="smile_txt pt-20">현재 수강중인 수업은 어떠신가요?<br><span class="imp">표정 아이콘</span>을 클릭해 주세요!<br>여러분의 소중한
                    의견이 더 좋은 수업을 만듭니다.</div>
                <div class="cb"></div>
            </div>
        </div>
    </div> -->

      <div class="inf_box_smile_bg" v-if="showSmileSheet==true">
        <div class="inner_box">
            <i class="fa fa-times btn_smile_close" aria-hidden="true" v-on:click="hideClassSmile()"></i>

            <div class="smile_title">{{classinfo.classname}}</div>
            <div class="smile_box clear">
                <div class="clear">
                    <div class="icon_box float-left" v-on:click="sendSmileSheet(1)">
                        <img src="../assets/img/score1.png" class="img_size_smile" v-on:mouseover="changeImgover(1)" v-on:mouseout="changeImgOut(1)" id="smile_img1">
                    </div>
                    <div class="icon_box float-left" v-on:click="sendSmileSheet(3)">
                        <img src="../assets/img/score3.png" class="img_size_smile" v-on:mouseover="changeImgover(2)" v-on:mouseout="changeImgOut(2)" id="smile_img3">
                    </div>
                    <div class="icon_box float-left" v-on:click="sendSmileSheet(5)">
                        <img src="../assets/img/score5.png" class="img_size_smile" v-on:mouseover="changeImgover(3)" v-on:mouseout="changeImgOut(3)" id="smile_img5">
                    </div>
                </div>

                <div class="smile_txt pt-20">강사님이 주신 첨삭이 어떠셨는지요?<br><span class="imp">표정 아이콘</span>을 클릭해 주세요!<br>여러분의 소중한
                    의견이 더 좋은 수업을 만듭니다.</div>
                <div class="cb"></div>
            </div>
        </div>
    </div>

    <div class="inf_box_smile_bg" v-show="inf_box_class_smile===true && inf_only_write_class=='N'" style="display:none;">

        <div class="inner_box">
            <img src="../assets/img/modal-close.png" class="close-img" alt="" v-on:click="inf_box_class_smile=false">
            <div class="smile_title">{{ inf_name_class_smile }}</div>
            <div class="smile_box clear">
                <div class="clear">
                    <div class="icon_box float-left" v-on:click="setSmile(1)">
                        <img src="../assets/img/score1.png" class="img_size_smile" v-on:mouseover="changeImgover(1)" v-on:mouseout="changeImgOut(1)" id="smile_img1">
                    </div>
                    <div class="icon_box float-left" v-on:click="setSmile(2)">
                        <img src="../assets/img/score3.png" class="img_size_smile" v-on:mouseover="changeImgover(2)" v-on:mouseout="changeImgOut(2)" id="smile_img3">
                    </div>
                    <div class="icon_box float-left" v-on:click="setSmile(3)">
                        <img src="../assets/img/score5.png" class="img_size_smile" v-on:mouseover="changeImgover(3)" v-on:mouseout="changeImgOut(3)" id="smile_img5">
                    </div>
                </div>

                <div class="smile_txt pt-20">현재 수강중인 수업은 어떠신가요?<br><span class="imp">표정 아이콘</span>을 클릭해 주세요!<br>여러분의 소중한
                    의견이 더 좋은 수업을 만듭니다.</div>
                <div class="cb"></div>
            </div>
            <div class="txt-center modal-txt-close">
                <span class="tutor" @click="today_close()">오늘 하루 열지 않기</span>
            </div>
        </div>
    </div>
</div>
</div>
</template>

<script>
import Menu from '../components/inc_menu.vue'
import TutorModal from '../components/pop_tutor.vue'
import ManagerModal from '../components/pop_manager.vue'
import WtGuideModal from '../components/pop_wtguide_email.vue'
import EvReport from '../components/inc_ev_report.vue'
import { Selection, Editor, SfdtExport, TextExport } from '@syncfusion/ej2-vue-documenteditor';

export default {
    name: 'Class',
    components: {
        Menu,
        TutorModal,
        ManagerModal,
        WtGuideModal,
        EvReport,
    },
    props: {
        msg: String
    },
    provide: {
         DocumentEditor : [SfdtExport, TextExport, Selection, Editor]
    },
    created() {
        if(location.hostname == "stagest.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
        }else if(location.hostname == "st.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "student.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "m.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.href.includes("how")){
            if(location.href.includes("stage")){
                this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
            }else{
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }
        }else{
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }
        this.$store.commit("loginCheck");

    },
    data: () => ({
        inf_box_class_smile: false,
        inf_only_write_class : "Y",
        inf_idx_class_smile: "",
        inf_name_class_smile: "",
        tutorVisible: false,
        mangerVisible: false,
        tab: 1,
        is_loader: false,
        tab_check: 1,
        is_check: 0,
        is_tab_ev: false,
        classid: "",
        slt_gubun: "MEMBER",
        idx: 0,
        classinfo: {},
        syl_plan: {},
        eval_plan: {},
        ev_txt: {
            fluency_str: "유창성",
            accuracy_str: "정확성",
            pronunciation_str: "발음",
            comprehension_str: "이해도",
            participation_str: "",
            preparation_str: ""
        },
        attend_days: [{
            attdate: "2018-02-04",
            stat: 1
        }, {
            attdate: "2018-02-05",
            stat: 2
        }, {
            attdate: "2018-02-06",
            stat: 3
        }, {
            attdate: "2018-02-07",
            stat: 4
        }, {
            attdate: "2018-02-08",
            stat: 5
        }],
        lat: "",
        lng: "",

        cur_tutor_email: "",
        cur_tutor_ename: "",
        cur_tutor_photo: "",
        cur_tutor_lang: "",

        cur_manger_email: "",
        cur_manger_ename: "",
        cur_manger_photo: "",
        cur_manger_intu: "",

        //라이팅
        pop: {
            email: false,
            sms: false,
            classid: 0,
            memberseq: 0,
            info: {
                writing_date: "",
                url_topic: "",
                correction_date: "",
                guide_content: "",
                writing_num: 0
            },
        },
        writingList: [],
        showSendWriting: false,
        sendWritingNum: "-",
        sendWritingIdx: 0,
        topicInfo: {
            idx: "",
            title: "",
            content: ""
        },
        showTopic: false,
        showSmileSheet: false,
        writingInfo: {
            use_writing_ev: 'N'
        },

        //출결
        cal_year: "",
        cal_month: "",
        cal_month_str: "",
        cal_days: [{
            txt: "1",
            style: ""
        }, {
            txt: "2",
            style: ""
        }],
        is_axios : false,
        writingListAttend : [],
        writingUserListAttend : [],
        writing_rate: [],
        correction_rate:'',
        cnt_month_writing:'',
        complete_per:'',
        writing_date_check : false,
        ev_check_writing:true,
    }),
    mounted() {
        //    this.doc_del_rendar();
        //    console.log(this.$route.query.classid);
        this.classid = this.$route.query.classid;
        this.getClassInfo();
        this.getUserWritingList();

        var today = new Date();
        this.cal_year = today.getFullYear();
        this.cal_month = today.getMonth() + 1;
        let year = today.getFullYear(); // 년도
        let month = today.getMonth() + 1; // 월
        let date = today.getDate(); // 날짜
        // let day = today.getDay();
        var todate = year + "" + month + "" + date
        if (localStorage.getItem("smilePop") != todate + "/" + localStorage.getItem("uidx")) {
            this.getSmileInfo4Week();
        }
        console.log(location.href);
        console.log(location.host);
    },
    methods: {
        setAttendEnd: function (classid, idx_attend) {
            var me = this;
            console.log(classid);
            console.log(idx_attend);
            if (navigator.geolocation) { // GPS를 지원하면
                navigator.geolocation.getCurrentPosition(function (position) {
                    me.lat = position.coords.latitude;
                    me.lng = position.coords.longitude;

                    // me.lat = "37.5108295";
                    // me.lng = "127.02928809999999";

                    var addr = "";
                    var params = {
                        classid: classid,
                        idx_attend: idx_attend,
                        lat: me.lat,
                        lng: me.lng,
                        addr: addr,
                        tmr: Date.now(),
                        idx_attend_student: localStorage.getItem("uidx")
                    };
                    // console.log(params);
                    me.axios.get(me.$store.state.host + "/rest/mobile/setAttendStudentEnd", {
                            params: params
                        })
                        .then(function (res) {
                            if (res.data.err == 0) {
                                alert("Class 퇴실 완료");
                                me.getClassInfo();
                            } else {
                                alert(res.data.err_msg);
                            }
                            // // console.log(res.data);
                            // me.getClassInfo();
                            // me.is_loader = false;
                            console.log(res);
                        });

                    // return true;
                }, function (error) {
                    alert(error.message);
                    return false;
                }, {
                    enableHighAccuracy: false,
                    maximumAge: 0,
                    timeout: Infinity
                });
            } else {
                alert('GPS를 지원하지 않습니다');
                return false;
            }
        },
        setAttend: function (classid, idx_attend) {
            if(this.is_axios){
                alert("출석 처리 진행중입니다.");
                return false;
            }
            var me = this;
            console.log(classid);
            console.log(idx_attend);
            if (navigator.geolocation) { // GPS를 지원하면
                navigator.geolocation.getCurrentPosition(function (position) {
                    me.lat = position.coords.latitude;
                    me.lng = position.coords.longitude;

                    // me.lat = "37.5108295";
                    // me.lng = "127.02928809999999";

                    var addr = "";
                    var params = {
                        classid: classid,
                        idx_attend: idx_attend,
                        lat: me.lat,
                        lng: me.lng,
                        addr: addr,
                        tmr: Date.now(),
                        uidx: localStorage.getItem("uidx")
                    };
                    // console.log(params);
                    me.axios.get(me.$store.state.host + "/rest/mobile/setAttend", {
                            params: params
                        })
                        .then(function (res) {
                            if (res.data.err == 0) {
                                alert("Class 입실 완료");
                                setTimeout(function(){
                                    me.is_axios = true;
                                },1000);
                                me.getClassInfo();
                                // location.reload();
                            } else {
                                alert(res.data.err_msg);
                            }
                            // // console.log(res.data);
                            // me.getClassInfo();
                            // me.is_loader = false;
                            console.log(res);
                        });

                    // return true;
                }, function (error) {
                    alert(error.message);
                    return false;
                }, {
                    enableHighAccuracy: false,
                    maximumAge: 0,
                    timeout: Infinity
                });
            } else {
                alert('GPS를 지원하지 않습니다');
                return false;
            }
        },
        writingDownload: function (itm) {            
            window.open(itm.url_writing);
        },
        mswritingDownload: function (itm) {            
            var me = this;
            window.open(me.$store.state.host+'/rest/writing/downloadMs?idx='+itm.idx);
        },
        showEvPop: function (itm) {
            console.log(itm.idx);
            window.open("/pop_evview?idx_wu=" + itm.idx, "pop_evwriting", "width=960,height=700");
        },
        today_close: function () {
            let today = new Date();

            let year = today.getFullYear(); // 년도
            let month = today.getMonth() + 1; // 월
            let date = today.getDate(); // 날짜
            // let day = today.getDay();
            var todate = year + "" + month + "" + date;
            // console.log(todate);
            localStorage.setItem('smilePop', todate + "/" + localStorage.getItem("uidx"));
            this.inf_box_class_smile = false;
        },
        //출결
        set_cal_pre: function () {
            this.cal_month = this.cal_month - 1;
            if (this.cal_month < 1) {
                this.cal_year = this.cal_year - 1;
                this.cal_month = 12;
            }
            if (this.tab == 2) {
                if(this.classinfo.use_writing == "Y") {
                    this.getAttendList();
                } else {
                    this.getAttendListOld();
                    this.is_tab_ev = false;
                }
             
               
            }

            this.set_cal();
        },

        set_cal_next: function () {
            this.cal_month = this.cal_month + 1;
            if (this.cal_month > 12) {
                this.cal_year = this.cal_year + 1;
                this.cal_month = 1;
            }
            if (this.tab == 2) {
                if(this.classinfo.use_writing == "Y") {
                    this.getAttendList();
                } else {
                    this.getAttendListOld();
                    this.is_tab_ev = false;
                }
        
                
            }

            this.set_cal();
        },
        get_ym: function () {
            var mon = new Array();
            mon[0] = "1월";
            mon[1] = "2월";
            mon[2] = "3월";
            mon[3] = "4월";
            mon[4] = "5월";
            mon[5] = "6월";
            mon[6] = "7월";
            mon[7] = "8월";
            mon[8] = "9월";
            mon[9] = "10월";
            mon[10] = "11월";
            mon[11] = "12월";

            this.cal_month_str = mon[this.cal_month - 1];
        },
        set_cal: function () {
            this.get_ym();

            var year = this.cal_year;
            var month = this.cal_month;

            var getDayTxt = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
            var at_day = this.classinfo.weekLessonEngText.replace(/ /gi, '').split(",");
            var at_sdate = this.classinfo.sdate;
            var at_edate = this.classinfo.edate;

            this.cal_days = [];
            let toDay = new Date();
            let startDay = new Date(year, month - 1, 1);
            let endDay = new Date(year, month, 0);

            for (let i = 0; i < startDay.getDay(); i++) {
                this.cal_days.push({
                    txt: "",
                    style: ""
                });
            }

            // console.info(toDay);
            for (let i = 1; i <= endDay.getDate(); i++) {
                let dayinfo = {
                    txt: i.toString(),
                    style: ""
                };
                let tday = new Date(year, month - 1, i);

                if (at_sdate <= this.getDateToString(tday) && this.getDateToString(tday) <= at_edate &&
                    at_day.indexOf(getDayTxt[tday.getDay()]) >= 0) {
                    // console.log(this.getDateToString(tday), getDayTxt[tday.getDay()], tday.getDay(), at_day.indexOf(getDayTxt[tday.getDay()]));
                    dayinfo.style = "bg-scheduled";
                }

                for (let j = 0; j < this.attend_days.length; j++) {
                    // console.log(this.getDateToString(tday), this.attend_days[j].attdate);
                    if (this.getDateToString(tday) == this.attend_days[j].attdate) {
                        switch (this.attend_days[j].stat) {
                            case "Y":
                            case "L":
                                dayinfo.style = "bg-attend";
                                break;
                            case "C":
                            case "N":
                                dayinfo.style = "bg-absent";
                                break;
                            case "BZ":
                            case "VA":
                                dayinfo.style = "bg-cancel";
                                break;
                                // default:
                                // 	dayinfo.style = "circle_gra";
                                // 	break;
                            case "AR":
                                dayinfo.style = "bg-reasons";
                                break;
                            case "H":
                                dayinfo.style = "";
                                break;

                        }
                    }
                }
                // console.info(dayinfo);
                if (toDay.getDate() == i && toDay.getMonth() == (month - 1) && toDay.getFullYear() == year.toString()) {
                    dayinfo.style = dayinfo.style + " col-point";
                }

                this.cal_days.push(dayinfo);
            }

            for (let i = endDay.getDay(); i < 6; i++) {
                this.cal_days.push({
                    txt: "",
                    style: ""
                });
            }
            // this.cal_month_str = mon[this.cal_month-1];
        },
        getAttendListOld: function () {
            console.log("get attend list");
            var params = {
                classid: this.classid,
                syear: this.cal_year,
                smonth: this.cal_month,
                uidx: localStorage.getItem("uidx"),
                tmr: Date.now()
            };

            var me = this;
            this.axios.get(this.$store.state.host + "/rest/mobile/getAttendList_new", {
                params: params
            }).then(function (res) {
                console.log(res);
                if (res.data.err == 0) {
                    me.attend_days = res.data.attend_days;
                    if (!me.attend_days) {
                        me.attend_days = [];
                    }
                    me.set_cal();
                } else {
                    alert(res.data.err_msg);
                }
            });
        },
        getAttendList: function() {

            var params = { 
                idx_itm_class: this.classid,
                search_year: this.cal_year,
                search_month: this.cal_month,
                uidx: localStorage.getItem("uidx")
            };
            var me = this;
            console.log(params); 
            me.set_cal();
            this.axios.get(this.$store.state.host + "/rest/writing/getWritingListExtand", {params: params})
			.then(function (res) {
                console.log(res);
                me.writingUserListAttend = res.data.info.list;
                me.complete_per = res.data.info.complete_per;
            });

        },

        hideSmileSheet: function () {
            this.showSmileSheet = false;
        },
        sendSmileSheet: function (point) {
            this.showSmileSheet = false;
            var param = {
                idx_itm_class_writing_user: this.topicInfo.idx,
                point: point,
                uidx: localStorage.getItem("uidx")
            };
            var me = this;
            this.axios.post(this.$store.state.host + "/rest/writing/setSmileSheet_new", param).then(function (res) {
                me.getUserWritingList();

                if (res.data.err > 0) {
                    alert(res.data.err_msg);
                }
            });
        },
        hideClassSmile: function () {
            this.showSmileSheet = false;
        },
        changeImgOut: function (idx) {
            if (idx == 1) {
                document.getElementById("smile_img1").src = "https://stagehq.carrotenglish.net/resource/itmhq/img/score1_new.png";
            } else if (idx == 2) {
                document.getElementById("smile_img3").src = "https://stagehq.carrotenglish.net/resource/itmhq/img/score3_new.png";
            } else {
                document.getElementById("smile_img5").src = "https://stagehq.carrotenglish.net/resource/itmhq/img/score5_new.png";
            }
        },
        changeImgover: function (idx) {
            // alert("a");
            if (idx == 1) {
                document.getElementById("smile_img1").src = "https://stagehq.carrotenglish.net/resource/itmhq/img/score1_on_new.png";
            } else if (idx == 2) {
                document.getElementById("smile_img3").src = "https://stagehq.carrotenglish.net/resource/itmhq/img/score3_on_new.png";
            } else {
                document.getElementById("smile_img5").src = "https://stagehq.carrotenglish.net/resource/itmhq/img/score5_on_new.png";
            }

        },
        sendWritingConfirm: function () {
            var formData = new FormData();
            var wfile = document.querySelector('#writingFile');
            // console.log(wfile.files);
            if (wfile.files.length <= 0) {
                alert("파일을 선택해주세요.");
                return false;
            }
            formData.append("idx_itm_class_writing_user", this.sendWritingIdx);
            formData.append("wfile", wfile.files[0]);
            formData.append("uidx", localStorage.getItem("uidx"));
            var me = this;
            this.axios.post(this.$store.state.host + '/rest/writing/putUserWriting_new', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (res) {
                if (res.data.err == 0) {
                    alert("제출이 완료되었습니다.");
                    me.getUserWritingList();
                    me.showSendWriting = false;
                }
            });
        },
        sendWriting: function (info) {
            this.sendWritingNum = info.writing_num;
            this.sendWritingIdx = info.idx;
            this.showSendWriting = true;

        },
        correctionDownload: function (itm) {
            if (itm.smilesheet == 0) {
                this.showSmileSheetPop(itm.idx);
            }
            window.open(itm.url_correction);
        },
        showSmileSheetPop: function (idx_itm_class_writing_user) {
            this.topicInfo.idx = idx_itm_class_writing_user;
            this.showSmileSheet = true;
        },
        showTopicPop: function (itm) {
            this.pop.info.idx_hq = itm.idx_itm_emp;
            this.pop.info.writing_date_text = itm.writing_date_text;
            this.pop.info.writing_date = itm.writing_date;
            this.pop.info.guide_content = itm.guide_content;
            this.pop.info.url_topic = itm.url_topic;
            this.pop.info.writing_num = itm.writing_num;
            this.pop.email = true;

            // this.topicInfo.title = itm.title;
            // this.topicInfo.content = itm.guide_content;

            // this.showTopic = true;
        },
        showManager(email, ename, photo, intu) {
            this.cur_manger_email = email;
            this.cur_manger_ename = ename;
            this.cur_manger_photo = photo,
                this.cur_manger_intu = intu;
            this.mangerVisible = true;
        },
        showTutor(email, ename, photo, lang) {
            this.cur_tutor_email = email;
            this.cur_tutor_ename = ename;
            this.cur_tutor_photo = photo;
            this.cur_tutor_lang = lang;
            this.tutorVisible = true;
        },
        vue_close(state) {
            this.tutorVisible = state;
            this.mangerVisible = state;
        },
        changeTab(target) {
            // console.log("Asd");
            this.tab = target;
            if (this.tab == 2) {
                if(this.classinfo.use_writing == "Y") {
                    this.getAttendList();
                } else {
                    this.getAttendListOld();
                }
              
            } else if (this.tab == 4) {
                // console.log("tab 4")
                if(this.classinfo.use_writing == "Y") {
                     this.is_tab_ev = false;
                }else{
                    this.is_tab_ev = true;
                }
               
            }
        },
        getClassInfo: function () {
            var me = this;
            var params = {
                uidx: localStorage.getItem("uidx"),
            };
            this.axios.get(this.$store.state.host + '/rest/mobile/classinfo_new/' + me.classid, {
                params: params
            }).then(function (res) {
                console.log(res); 
                if (res.data.err == 0) {
                    me.classinfo = res.data;
                    console.log(me.classinfo);
                    me.syl_plan = (res.data.syl_plan ? res.data.syl_plan : {
                        idx: 0,
                        cont: ""
                    });
                    console.log(me.syl_plan);
                    console.log(res.data.only_write);
                    me.inf_only_write_class = res.data.only_write;
                    if (me.classinfo.use_writing == 'Y') {
                        me.tab = "1";
                        me.ev_check_writing = false;
                    } else {
                        me.tab = "2";
                        me.getAttendListOld();
                    }
                } else {
                    alert(res.data.err_msg);
                }
                me.is_loader = false;
            });
        },
        getUserWritingList: function () {
            var me = this;
            var params = {
                idx_itm_class: me.classid,
                uidx: localStorage.getItem("uidx"),
                tmr: Date.now()
            };

            this.axios.get(this.$store.state.host + "/rest/writing/getUserWritingList_new", {
                    params: params
                })
                .then(function (res) {
                    me.writingInfo = res.data.info;
                    res.data.list.forEach(function(k){
                        
                        if(k.is_send =='Y') {
                            me.writingList.push(k);
                        }
                           
                    });                    
                    me.is_loader = false;
                    console.log(me.writingList);
                });
        },
        getDateToString(date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            return [year, month, day].join('-');
        },
        getSmileInfo4Week: function () {
            var me = this;
            var params = {
                tmr: Date.now(),
                uidx: localStorage.getItem("uidx"),
            }
            this.axios.get(this.$store.state.host + '/rest/mobile/getSmileInfo4Week_new', {
                params: params
            }).then(function (res) {
                if (res.data.err == 0) {
                    if (res.data.isSmileOn == true) {
                        me.inf_box_class_smile = true;
                        me.inf_name_class_smile = res.data.classname;
                        me.inf_idx_class_smile = res.data.classid;
                    }
                }
            });
        },
        setSmile: function (score) {
            // console.log("set smile state", score, this.inf_idx_class_smile);
            var me = this;
            var params = {
                classid: this.inf_idx_class_smile,
                score: score,
                tmr: Date.now(),
                uidx: localStorage.getItem("uidx"),
            };
            this.axios.post(this.$store.state.host + '/rest/mobile/setSmileInfo4Week_new', params).then(function (res) {
                if (res.data.err == 0) {
                    alert('Thank you. \nHave a nice day~');
                } else {
                    alert(res.data.err_msg);
                }
                me.inf_box_class_smile = false;
            });
        },
        wirtigComfirmPage: function(item,num) {
            location.href="/writing_send?classid="+this.classid+"&writing_idx="+item.idx+"&writing_num="+num;
        }
        ,
        modConfirmPage: function(item,num) {
            location.href="/writingMod?classid="+this.classid+"&writing_idx="+item.idx+"&writing_num="+num;
        },
        saveAsDocx: function() {
            this.$refs.documenteditor.save('sample', 'Docx');
        },
        modChangeFlag: function(w) {
            console.log(w.writing_date);
            var d1 = new Date(w.writing_date);
            var d2 = new Date();
            d2.setHours(23,59,59,0);
            d1.setHours(23,59,59,0);
            if( d2 > d1) {
         
                return true;
            } else {
            
                return false;
            }
        },
    }
    //   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;700&display=swap');

$point-color: #53CAFF;
$purple: #6974FF;
$gray: #B7B7B7;
$border-color: #E9E9E9;
$back-gray: #F5F5F5;

// 결석
$absent: #FF4068;
// 출석
$attend: #53CAFF;
// 휴강
$cancel: #FFB055;
// 예정
$scheduled: #E1E1E1;
// 공결
$reasons: #2FEECD;

.reason-pc {
    display: block;
}

.reason-mobile {
    display: none;
}

.close-div {
    width: 35%;
}

.class {
    .top {
        padding-top: 70px;
        background: url("../assets/img/top-bg.png") no-repeat right -80px;
        background-size: 300px;

        h2 {
            // padding-bottom: 20px;
        }

        p {
            font-size: 14px;
            letter-spacing: 0px;
            color: #000000;
            opacity: 1;
            margin-top: 10px;
            margin-bottom: 10px;
        }
    }

    .wrap {
        .btn-line-gr {
            background: #19ce60 0% 0% no-repeat padding-box;
            border-radius: 3px;
            opacity: 1;
            font-size: 14px;
            letter-spacing: 0px;
            color: #FFFFFF;
            opacity: 1;
            padding: 5px 10px;
            border: none;
        }

        .btn-line-gr-none {

            border-radius: 3px;
            opacity: 1;
            font-size: 14px;
            letter-spacing: 0px;
            color: #FFFFFF;
            opacity: 1;
            padding: 5px 10px;
            border: 1px solid #19ce60;
            color: #19ce60;
            background: white;

            i {
                color: #19ce60;
            }
        }
    }

    .class-info {
        border-radius: 20px;
        background: $back-gray;
        border: 1px solid $border-color;
        padding: 20px;
        width: 100%;
        margin: 0 auto;

        table {
            width: 100%;

            th {
                color: $gray;
                padding: 8px 10px 0 0;
                text-align: left;
                width: 80px;
            }

            td {}
        }
    }

    .tab {
        li {
            display: inline-block;
            text-align: center;
            padding: 30px 0 10px 0;
            color: $gray;
            border-bottom: 1px solid $border-color;
            font-size: 16px;

            &:nth-last-child(3),
            &:nth-last-child(3)~li {
                width: calc(100% / 3);
            }

            &:nth-last-child(4),
            &:nth-last-child(4)~li {
                width: calc(100% / 4);
            }

            img {
                display: block;
                margin: 0 auto;
            }

            &.active {
                font-weight: bold;
                color: #000000;
                border-bottom: 3px solid $point-color;
            }
        }
    }

    // writing 첨삭
    .writing {
        .none-writing {
            display: table;
            min-height: 250px;
            width: 100%;

            p {
                display: table-cell;
                vertical-align: middle;
                text-align: center;
                color: var(--unnamed-color-b7b7b7);
                text-align: center;
                font-size: 16px;
                font-weight: bold;
                letter-spacing: 0px;
                color: #B7B7B7;
                opacity: 1;
            }
        }

        .lecture {
            margin-top: 20px;
            // #F5F5F5 0% 0% no-repeat padding-box;
            border-bottom: 10px solid #F5F5F5;
            padding-top: 20px;

            &:last-child {
                border-bottom: 0px solid #F5F5F5;
            }

            .con {
                h3 {
                    font-size: 20px;
                }
            }
        }

        table {
            width: 100%;

            th {
                color: $gray;
                padding: 8px 10px 0 0;
                text-align: left;
                width: 60px;
                font-size: 14px;
            }

            td {
                font-size: 14px;

                .view02 {
                    background: #F5F5F5 0% 0% no-repeat padding-box;
                    border-radius: 12px;
                    font-size: 12px;
                    letter-spacing: 0px;
                    color: #53CAFF;
                    opacity: 1;
                    padding: 3px 10px;
                }
            }
        }
    }

    // 출결
    .calendar-wrap {
        .calendar-top {
            text-align: center;
            margin-top: 25px;

            li {
                display: inline-block;
                vertical-align: middle;
                padding: 0 10px;
            }
        }

        .calendar-col {
            // background: #F5F5F5;
            padding-top: 11px;
            padding-bottom: 11px;
            margin-top: 15px;

            .wrap {
                width: 100%;
            }

            span {
                font-size: 14px;
                margin-right: 10px;

                &::before {
                    content: '';
                    display: inline-block;
                    width: 10px;
                    height: 10px;
                    border-radius: 5px;
                    margin-right: 5px;
                }

                &.attend::before {
                    background: $attend;
                }

                &.absent::before {
                    background: $absent;
                }

                &.cancel::before {
                    background: $cancel;
                }

                &.scheduled::before {
                    background: $scheduled;
                }

                &.reasons::before {
                    background: $reasons;
                }
            }
        }

        .calendar {
            // margin-top: 15px;
            background: #ffffff;
            padding: 20px;

            .day {
                font-weight: bold;
                width: 100%;

                li {
                    display: inline-block;
                    text-align: center;
                    width: calc(100% / 7);
                }
            }

            .date {
                width: 100%;

                li {
                    display: inline-block;
                    text-align: center;
                    width: calc(100% / 7);
                    position: relative;
                    padding: 10px 0;
                    cursor: pointer;

                    span {
                        padding: 5px;
                        border-radius: 3px;

                        &.bg-attend {
                            background: #53CAFF;
                            min-width: 28px;
                            width: 28px;
                            max-width: 28px;
                            display: inline-block;
                            color: #ffffff;
                        }

                        &.bg-cancel {
                            background: #FFB055;
                            min-width: 28px;
                            width: 28px;
                            max-width: 28px;
                            display: inline-block;
                            color: #ffffff;
                        }

                        &.bg-scheduled {
                            background: $scheduled;
                            min-width: 28px;
                            width: 28px;
                            max-width: 28px;
                            display: inline-block;
                        }

                        &.bg-absent {
                            min-width: 28px;
                            width: 28px;
                            max-width: 28px;
                            display: inline-block;
                            background: #FF4068;
                            color: #ffffff;
                        }

                        &.bg-reasons {
                            background: #2FEECD;
                            min-width: 28px;
                            width: 28px;
                            max-width: 28px;
                            display: inline-block;
                        }
                    }

                }
            }
        }
    }

    .syllabus-wrap {
        .none-syllabus {
            display: table;
            min-height: 250px;
            width: 100%;

            p {
                display: table-cell;
                vertical-align: middle;
                text-align: center;
                color: var(--unnamed-color-b7b7b7);
                text-align: center;
                font-size: 16px;
                font-weight: bold;
                letter-spacing: 0px;
                color: #B7B7B7;
                opacity: 1;
            }
        }

        .syllabus-col {
            width: 90%;
            margin: 0 auto;
            padding-top: 10px;

            .tit_txt {
                font-size: 16px;
                color: black;
                font-weight: bold;
                line-height: 16px;
                margin: 10px 0 20px 0;
            }

            .syl_txt {
                text-align: left;
                font-size: 14px;
                letter-spacing: 0px;
                color: #000000;
                opacity: 1;
            }

            .timeline {
                padding-left: 40px;

                .timeline-item {
                    // padding: 3em 2em 2em;
                    position: relative;
                    color: rgba(black, .7);
                    border-left: 1px solid #F5F5F5;
                    padding-left: 32px;
                    padding-right: 32px;
                    padding-top: 35px;
                    padding-bottom: 10px;

                    p {
                        font-size: 14px;
                        letter-spacing: 0px;
                        color: #000000;
                        opacity: 1;
                    }

                    .hour {
                        position: absolute;
                        left: -40px;
                        top: 5px;
                        text-align: center;
                        font-size: 14px;
                        color: #000000;
                        opacity: 1;
                    }

                    &::before {
                        content: attr(date-is);
                        position: absolute;
                        left: 2em;
                        font-weight: bold;
                        top: 0.5em;
                        background: #F5F5F5 0% 0% no-repeat padding-box;
                        border-radius: 12px;
                        font-size: 12px;
                        letter-spacing: 0px;
                        color: #53CAFF;
                        opacity: 1;
                        padding: 0px 10px;
                        display: block;
                    }

                    &::after {
                        width: 5px;
                        height: 5px;
                        display: block;
                        top: 1em;
                        position: absolute;
                        left: -3px;
                        border-radius: 10px;
                        content: '';
                        // border: 2px solid $border-color;
                        background: #53CAFF;
                    }
                }
            }

        }

        .lession-plan {
            ul {
                li {
                    border-bottom: 1px dashed #E9E9E9;
                    padding-top: 14px;
                    padding-bottom: 14px;

                    &:first-child {
                        border-top: 1px dashed #E9E9E9;
                    }

                    div {
                        &:first-child {
                            display: table;

                            p {
                                background: #53CAFF 0% 0% no-repeat padding-box;
                                opacity: 1;
                                text-align: center;
                                width: 58px;
                                height: 58px;
                                color: #FFFFFF;
                                color: white;
                                border-radius: 50%;
                                line-height: 1.2;
                                box-sizing: border-box;
                                padding-top: 7px;
                            }
                        }

                        &:last-child {
                            h1 {
                                text-align: left;
                                font-weight: bold;
                                letter-spacing: 0px;
                                color: #000000;
                            }

                            p {
                                text-align: left;
                                font-size: 14px;
                                letter-spacing: 0px;
                                color: #000000;
                            }
                        }
                    }
                }
            }
        }

    }

    .ev-wrap {
        .calendar-top {
            text-align: center;
            margin-top: 25px;

            li {
                display: inline-block;
                vertical-align: middle;
                padding: 0 10px;
            }
        }

        .none-ev {
            display: table;
            min-height: 250px;
            width: 100%;

            p {
                display: table-cell;
                vertical-align: middle;
                text-align: center;
                color: var(--unnamed-color-b7b7b7);
                text-align: center;
                font-size: 16px;
                font-weight: bold;
                letter-spacing: 0px;
                color: #B7B7B7;
                opacity: 1;
            }
        }

        .ev-info {
            width: 90%;
            margin: 0 auto;

            .ev-title-wrap {
                .ev-title {
                    margin-top: 24px;
                    text-align: left;
                    font-size: 20px;
                    letter-spacing: 0px;
                    color: #53CAFF;
                }

                .ev-writer {
                    font-size: 14px;
                    letter-spacing: 0px;
                    color: #000000;
                    margin-top: 5px;
                }

                .ev-wdate {
                    font-size: 14px;
                    letter-spacing: 0px;
                    color: #B7B7B7;
                    margin-top: 20px;
                    margin-bottom: 30px;
                }
            }

            .ev-info-wrap {
                .info-title {
                    text-align: left;
                    font-size: 14px;
                    letter-spacing: 0px;
                    color: #000000;
                    opacity: 1;
                    font-weight: bold;
                    padding-bottom: 10px;
                    border-bottom: 1px solid #B7B7B7;
                    ;

                    .ico-r {
                        display: inline-block;
                        width: 17px;
                        height: 17px;
                        color: #fff;
                        background-color: #53CAFF;
                        text-align: center;
                        border-radius: 100%;
                        font-size: 14px;
                        line-height: 1;
                        font-weight: bold;
                        margin-right: 5px;
                    }
                }

                .info-content {
                    text-align: left;
                    font-size: 14px;
                    letter-spacing: 0px;
                    color: #000000;
                    opacity: 1;

                    .overall-title {
                        padding-top: 10px;
                    }

                    .overall-body {
                        text-align: left;
                        font-size: 14px;
                        letter-spacing: 0px;
                        color: #000000;
                    }
                }

                .graph-bar-wrap {
                    .graph-bar-head {
                        display: table;
                        margin-top: 15px;

                        .graph-bar-head-tit-fir {
                            width: 180px;
                            height: 30px;
                            display: table-cell;
                        }

                        .graph-bar-head-tit {
                            width: 45px;
                            height: 30px;
                            text-align: center;
                            display: table-cell;
                            vertical-align: bottom;
                            font-size: 12px;
                            color: #B7B7B7;
                            line-height: 14px;
                        }

                        .fair {
                            width: 100px;
                        }

                        .good {
                            width: 70px;
                        }

                        .very-good {
                            width: 100px;
                        }
                    }

                    .graph-bar-body {
                        clear: both;
                        padding-top: 10px;

                        .graph-bar-body-list {
                            clear: both;

                            .graph-bar-body-item {
                                clear: both;
                                height: 30px;
                                padding-bottom: 20px;

                                .graph-bar-tit {
                                    width: 120px;
                                    height: 20px;
                                    font-size: 13px;
                                    line-height: 20px;
                                    float: left;
                                    font-weight: bold;
                                }

                                .graph-bar-box {
                                    width: 81px;
                                    height: 15px;
                                    margin-top: 3px;
                                    background-color: #e6e6e6;
                                    border-left: 1px solid #ffffff;
                                    float: left;
                                }

                                &.col-s1 .graph-bar-box.on {
                                    background-color: #9FAFFF;
                                }

                                &.col-s2 .graph-bar-box.on {
                                    background-color: #92C8FF;
                                }

                                &.col-s3 .graph-bar-box.on {
                                    background-color: #31B3ED;
                                }

                                &.col-s4 .graph-bar-box.on {
                                    background-color: #53CAFF;
                                }

                                &.col-s5 .graph-bar-box.on {
                                    background-color: #9AE0FF;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

.footer {
    position: static;
}

.inf_box_smile_bg {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    padding: 180px 0;

    .inner_box {
        // height: 150px;
        width: calc((100% - 30px)/2);
        min-width: 320px;
        max-width: 500px;
        margin: auto;
        background: white;
        border-radius: 10px;
        position: relative;

        .modal-txt-close {
            span {
                color: white;
                cursor: pointer;
            }
        }

        .close-img {
            position: absolute;
            right: 0;
            top: -30px;
            cursor: pointer;
        }

        .button {
            margin-top: 10px;
            background: #53CAFF 0% 0% no-repeat padding-box;
            border-radius: 3px;
            opacity: 1;
            font-size: 14px;
            letter-spacing: 0px;
            color: #FFFFFF;
            opacity: 1;
            padding: 5px 10px;
            border: none;
        }
    }

    .smile_title {
        color: var(--unnamed-color-53caff);
        text-align: center;
        font-size: 20px;
        letter-spacing: 0px;
        color: #53CAFF;
        opacity: 1;
        font-weight: bold;
        padding-top: 20px;
    }

    .btn_smile_close {
        float: right;
        font-size: 48px;
        color: white;
        margin-right: 10px;
        cursor: pointer;
    }

    .smile_box {
        background-color: #fff;
        text-align: center;
        padding: 20px 5%;
        border-radius: 10px;

        .smile_txt {
            font-size: 16px;
            line-height: 140%;

            // color:white;
            .imp {
                font-size: 16px;
                line-height: 140%;
                font-weight: bold;
                color: #53CAFF;
                // color:$main_txt_color;
            }
        }

        .icon_box {
            padding-top: 10px;
            width: 33.33%;
            text-align: center;
            cursor: pointer;

            .img_size_smile {
                width: 92px;
                height: 92px;
            }
        }
    }
}

.view01 {
    font-size: 14px;
    background: #ffffff;
    color: #53CAFF;
    border-radius: 10px;
    padding: 2px 10px;
}
.ebook-title{
  padding-right: 10px;
  color: #53CAFF;
}
.writing_attend {
        padding-top: 20px;
       table {
            padding-top: 20px;
            width: 100%;
            margin: 0 auto;
            border: 1px solid black;
            border-collapse: collapse;
            text-align: center;
        }

        th {
            font-family: '나눔고딕',NanumGothic,'맑은고딕',MalgunGothic,'돋움',Dotum,Helvetica,sans-serif;
            font-size: 12px;
            border:1px solid #ededed !important;
            font-weight: normal; 
            line-height: 19px;
            color:gray;
            padding-top: 9px !important;
            padding-bottom: 7px !important;
        }

        td {
            font-family: '나눔고딕',NanumGothic,'맑은고딕',MalgunGothic,'돋움',Dotum,Helvetica,sans-serif;
            font-size: 12px;
            border:1px solid #ededed !important;
            font-weight: normal; 
            line-height: 19px;
            color:gray;
            padding-top: 9px !important;
            padding-bottom: 7px !important;
            vertical-align: middle;
        }

        tr:first-child th{
            background-color: rgba(82, 88, 88, 0);
        }
}

@media only screen and (max-width: 414px) {
    .close-div {
        width: 90%;
    }

    .reason-pc {
        display: none;
    }

    .reason-mobile {
        display: block;
    }

    .inf_box_smile_bg {
        padding-left: 20px;
        padding-right: 20px;
        box-sizing: border-box;
    }

    .wrap {
        width: 100%;

    }

    .class {
        .top {
            background: url("../assets/img/top-bg.png") no-repeat 160px -80px;
            background-size: 300px;

            &.wrap {
                width: 100%;
                padding-left: 5%;
            }

        }

        .naver-wrap {
            width: 90%;
            margin: 0 auto;
        }

        .naver-wrap1 {
            width: 90%;
            margin: 0 auto;
        }

        .class-info {
            width: 90%;
        }

        .tab {
            &.wrap {
                width: 100%;
            }

            li {
                font-size: 14px;
            }
        }

        .writing {
            .lecture {
                margin-top: 0px;
                border-top: none;
                border-bottom: 10px solid $border-color;

                .wrap {
                    .con {
                        padding-left: 20px;
                        padding-right: 20px;
                    }
                }
            }

            table {
                width: 100%;

                th {
                    color: $gray;
                    padding: 8px 10px 0 0;
                    text-align: left;
                    width: 60px;
                }
            }
        }

        // 출결
        .calendar-wrap {
            .calendar {
                margin-top: 15px;
            }

            .calendar-col {
                background: $back-gray;
                padding: 5px 0;
                font-size: 12px;

                .wrap {
                    width: 100%;
                    padding-left: 30px;
                }

                span {
                    margin-right: 5px;
                    font-size: 12px;
                }

                .attend {
                    padding-left: 5%;
                }
            }

            .calendar {
                padding: 0px;
            }
        }

        .ev-wrap {
            .ev-info {
                .ev-info-wrap {
                    .graph-bar-wrap {
                        .graph-bar-head {
                            .graph-bar-head-tit-fir {
                                width: 160px;
                            }

                            .graph-bar-head-tit {
                                width: 55px;
                            }
                        }
                    }

                    .graph-bar-wrap {
                        .graph-bar-body {
                            .graph-bar-body-list {
                                .graph-bar-body-item {
                                    .graph-bar-box {
                                        width: 50px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

@media only screen and (max-width: 375px) {
    .class {
        .calendar-wrap {
            .calendar-col {
                .wrap {
                    padding-left: 15px;
                }
            }
        }

        .ev-wrap {
            .ev-info {
                .ev-info-wrap {
                    .graph-bar-wrap {
                        .graph-bar-head {
                            .graph-bar-head-tit-fir {
                                width: 210px;
                            }

                            .graph-bar-head-tit {
                                width: 55px;
                            }
                        }
                    }

                    .graph-bar-wrap {
                        .graph-bar-body {
                            .graph-bar-body-list {
                                .graph-bar-body-item {
                                    .graph-bar-tit {
                                        width: 110px;
                                    }

                                    .graph-bar-box {
                                        width: 41px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
